import React from 'react';
import Main from './Main';
import { Route } from 'react-router-dom';

const MainRoutes = () => (
  <Route
    exact
      path="/"
      render={
        ({match}) => (
          <Main match={match} />
        )
      }
  />
);

export default MainRoutes;
